import { render } from "./MenuMaster.vue?vue&type=template&id=dd67e544&scoped=true"
import script from "./MenuMaster.vue?vue&type=script&lang=js"
export * from "./MenuMaster.vue?vue&type=script&lang=js"

import "./MenuMaster.vue?vue&type=style&index=0&id=dd67e544&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dd67e544"

export default script